import ContentLoading from 'component/LoadingComponent/ContentLoading';
import DataNotFound from 'component/shared/DataNotFound/DataNotFound';
import { API_BASE_URL } from 'configs/AppConfig';
import { END_POINTS } from 'constants/APIConstant';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import React from 'react';
import Modal from "react-bootstrap/Modal";
import { FormattedMessage } from "react-intl";
import { useParams } from 'react-router-dom';
import useSWR from "swr";
// import ReactGA from "react-ga4";

export default function Infograph() {

    const { id } = useParams();

    const infographData = useSWR({
        url: `${END_POINTS.INFOGRAPH}=${id}`,
    });

    React.useEffect(() => {
        const timeOut = setTimeout(() => {
            window.scrollTo(0, 0);
        }, 0);
        return () => {
            clearTimeout(timeOut)
        }
    }, [id])


    // ReactGA.initialize(END_POINTS.TRACKING_ID);

    // useEffect(() => {
    //   // Send pageview with a custom path
    //   ReactGA.send({
    //     hitType: "pageview",
    //     page: `/infograph/${id}`,
    //     title: `Infograph: ${infographData.data?.data?.name}`
    //   });
    // }, [id]);
    

    // preview
    const [imagePreview, setImagePreview] = React.useState('')
    const [show, setShow] = React.useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => {setShow(true)}


    const renderPhotosList = () => {
        const photoos =
          infographData.error ||
          infographData.isLoading ||
          infographData.data === undefined ||
          infographData.data === null
            ? []
            : infographData.data.data;
    
        const rendering = photoos.map(({infographicUrl} , i) => (
            <div key={i} className="col-12 col-md-6 col-lg-4 col-xl-3">
                <div className="text-center">
                    <div className="img-item position-relative">
                        <img 
                            className="img1"
                            src={infographicUrl ? `${API_BASE_URL}/${infographicUrl}` : process.env.PUBLIC_URL + "/image/newsr1.png"}
                            alt="ved-item"
                            loading="lazy"
                        />

                        <div className="preview" onClick={() => {
                            setImagePreview(infographicUrl)
                            handleShow()
                        }}>
                            <span>Preview</span>
                            <VisibilityOutlinedIcon />
                        </div>
                    </div>

                    {/* preview */}
                    <Modal
                        style={{ zIndex: "9999999999" }}
                        show={show}
                        onHide={handleClose}
                        centered
                    >
                        <Modal.Header style={{ padding: "1rem" }} closeButton>
                            <Modal.Title></Modal.Title>
                        </Modal.Header>

                        <Modal.Body style={{ padding: "1.5rem" , textAlign: 'center' }}>
                            <img 
                                className="w-100"
                                style={{minHeight: '300px' , maxHeight: '400px'}}
                                src={infographicUrl ? `${API_BASE_URL}/${imagePreview}` : process.env.PUBLIC_URL + "/image/newsr1.png"}
                                alt="ved-item"
                                loading="lazy"
                                onClick={handleShow}
                            />
                        </Modal.Body>
                    </Modal>
                </div>
            </div>
        ))
    
        return rendering;
      }

  return (
    <ContentLoading 
        isLoading={
            // infographData.error ||
            infographData.isLoading
        }
    >
        <div className="container">
            <div className='media-center'>
                <div className='m__title__magazine mb-0'>
                    <h3>
                        <FormattedMessage id="infographic-album" />
                    </h3>
                </div>

                <div className="row gy-4 gx-0 gx-md-4 my-3">
                    {Object.keys(renderPhotosList()).length > 0 ?
                        renderPhotosList()
                        :
                        <DataNotFound />
                    }
                </div>
            </div>
        </div>

    </ContentLoading>
  )
}
